 <template>
  <div class="ManageCourseDetailList">
    <div class="container-fluid paddding-right-0px">
      <div class="row vertical-align margin-bottom-2Perc">
        <div class="col-md-3 col-lg-3 padding-left-0px font-size-18px">
        </div>
        <div class="col-md-2 col-lg-2 padding-left-0px text-align-right font-size-18px">
          Course Type
        </div>
        <div class="col-md-3 col-lg-3 padding-left-0px font-size-18px">
          <select class="form-control" v-model="selectedCourseTypeValue">
            <option :value=constants.CourseType.Normal>Normal</option>
            <option :value=constants.CourseType.M365>Mentora Moments</option>
          </select>                  
        </div>
        <div class="col-md-4 col-lg-4">
        </div> 
      </div>
      <div class="table-responsive margin-Top-2Perc margin-left-0Point3Perc">
        <table class="table table-striped ">
          <thead>
            <tr v-if="getCourseList.length !== 0">
              <th class="text-align-center text-valign-middle font-size-15px border-right">Course Title</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Sub-Title</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Version</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Course Type</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Course Image</th>
              <th class="text-align-center text-valign-middle font-size-15px border-right">Created TS</th>
              <th class="text-align-center text-valign-middle font-size-15px">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="courseObj in getCourseList" :key="courseObj.CourseMasterId" v-bind:courseObj = "courseObj">
              <td class="text-align-center border-right padding-top-2Perc col-md-3 col-lg-3">{{courseObj.CourseTitle}}</td>
              <td class="text-align-center border-right padding-top-2Perc col-md-1 col-lg-1">{{courseObj.SubTitle}}</td>
              <td class="text-align-center border-right padding-top-2Perc col-md-1 col-lg-1">{{courseObj.Version}}</td>
              <td class="text-align-center border-right padding-top-2Perc col-md-1 col-lg-1">{{showCourseType(courseObj)}}</td>
              <td class="text-align-center border-right col-md-2 col-lg-2"><img class="imgWidthHeight img-background-color" :src="baseUrl + courseObj.CourseMasterId + '&' + Math.random()" :id="courseObj.CourseMasterId" @error="assignDefaultImage($event,courseObj.CourseMasterId)"></td>
              <td class="text-align-center border-right padding-top-2Perc col-md-2 col-lg-2">{{formatAndShowDate(courseObj.CreatedTS)}}</td>
              <td class="text-align-center padding-top-2Perc col-md-2 col-lg-2">
                <a class="cursor-pointer" @click="updateShowViewCourseDetailsOverlayFlag($event,true,courseObj)"> Details </a>|
                <a class="cursor-pointer" @click="updateShowEditCourseDetailsOverlayFlag($event,true,courseObj)"> Edit </a>|
                <a class="cursor-pointer" @click="setShowConfirmationBoxAsTrue($event,true,courseObj, 'delete')"> Delete </a>|
                <a class="cursor-pointer" @click="showCourseStructureToUser($event,courseObj)"> View Journey </a>|
                <a class="cursor-pointer" @click="setShowConfirmationBoxAsTrue($event,true,courseObj, 'copy_course')"> Copy Course</a>
                <!--|
                 <a class="cursor-pointer" > View Lesson </a> -->
              </td>
            </tr>
          </tbody>
       </table>
    </div>
  </div>
  <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="performAction"></confirmation-alert>
  <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  <view-course-details v-if="showViewCourseDetails" v-bind:selectedCourseObj="selectedCourseObj" @closeViewCourse="updateShowViewCourseDetailsFlag" :isComingFrom="constants.CourseSearchBarEnum.Course"></view-course-details>
  <edit-course-details @showSpinner="updateShowSpinnerFlag" v-if="showEditCourseDetails" v-bind:selectedCourseObj="selectedCourseObj" @closeEditCourse="updateShowEditCourseDetailsFlag" :isComingFrom="constants.CourseSearchBarEnum.Course"></edit-course-details>
  <!-- Show Spinner -->
  <div class="animationload" v-show="showSpinner">
    <div class="osahanloading"></div>
  </div>
  <loader></loader>
  </div>
</template>
<script scoped>
// import moment from 'moment-timezone'
import { constants } from '@/utils/constants'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import server from '@/utils/server'
import { filter } from 'lodash'
import ErrorImage from '../assets/images/imagenotfound.svg'
import { courseService } from '@/server-util/course-service'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import ViewCourseDetailsOverlay from '@/components/ViewCourseDetailOverlay'
import EditCourseDetailsOverlay from '@/components/EditCourseDetailOverlay'
import AlertBox from '@/components/AlertOverlay'
import Loader from '@/components/dashboard/Loader'
export default {
  created: function () {
    this.getCourses()
  },
  data: function () {
    return {
      constants: constants,
      currCourseType: constants.CourseType.Normal,
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      isCurrentlyShowingSpinner: false,
      showConfirmationBox: false,
      prefixString: '',
      postString: '',
      selectedCourseObj: null,
      showViewCourseDetails: false,
      showEditCourseDetails: false,
      baseUrl: server.baseURL() + '/api/CourseMaster/CourseImage?CourseMasterId=',
      isCourseCopied: false
    }
  },
  methods: {
    showCourseType: function (courseObj) {
      var courseTypeName = 'Normal'
      if (parseInt(courseObj.Type) === constants.CourseType.M365) {
        courseTypeName = 'Mentora Moments'
      }
      return courseTypeName
    },
    showCourseStructureToUser: function (event, courseObj) {
      localStorage.setItem('selectedSubMenu', 1)
      localStorage.setItem('selectedMenu', 2)
      this.$store.state.hightLightOptionExplictly = true
      this.selectedCourseObj = courseObj
      this.$router.push('/courses?courseId=' + this.selectedCourseObj.CourseMasterId)
    },
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    refreshCourseList (value) {
      // AK: used to refresh again list after editing given course
      if (value) {
        this.getCourses()
      }
    },
    assignDefaultImage: function (event, courseMasterId) {
      document.getElementById(courseMasterId).src = ErrorImage
    },
    getCourses: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined || storeObj.state.access_token !== '' || storeObj.state.access_token !== null) {
        // AK: Check weather Course List is already present on not
        if (storeObj.state.course_list.length === 0) {
          // this.showSpinner = true
          this.$store.state.isLoading = true
        }

        courseService.listCourses(storeObj.state.access_token)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store given course list
              storeObj.state.course_list = responseObj.data
              // AK: Hide Spinner if its showing to user
              if (this.$store.state.isLoading === true) {
                this.$store.state.isLoading = false
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if its showing to user
              if (this.$store.state.isLoading === true) {
                // this.showSpinner = false
                this.$store.state.isLoading = false
              }
            }
          }, errorObj => {
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            // AK: Hide Spinner if its showing to user
            if (this.$store.state.isLoading === true) {
              // this.showSpinner = false
              this.$store.state.isLoading = false
            }
          })
      } else {
        console.log('ACCESS TOKEN IS NOT FOUND HENCE DECLINE GET COURSE LIST OPERATION')
      }
    },
    updateShowSpinnerFlag (value) {
      // this.showSpinner = value
      this.$store.state.isLoading = value
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
      if (this.isCourseCopied) {
        this.isCourseCopied = false
        // AK: Refresh Course List
        this.getCourses()
      }
    },
    updateShowViewCourseDetailsFlag (value) {
      // AK: Used to close the View Course Overlay
      this.showViewCourseDetails = value
    },
    updateShowEditCourseDetailsFlag (value) {
      // AK: Used to close the Edit Course Overlay
      this.showEditCourseDetails = value
    },
    setShowConfirmationBoxAsTrue: function (event, flagToUpdate, courseObj, selectedAction) {
      this.showConfirmationBox = flagToUpdate
      this.selectedCourseObj = courseObj
      switch (selectedAction) {
        case 'delete':
          // AK: Used when user pressed delete to open delete Course overlay
          this.prefixString = 'Are you sure you want to delete '
          this.postString = 'master course \'' + this.selectedCourseObj.CourseTitle + '\'?'
          break
        case 'copy_course':
          // AK: Used when copy course
          this.prefixString = 'Are you sure you want to copy '
          this.postString = 'master course \'' + this.selectedCourseObj.CourseTitle + '\'?'
          break
      }
    },
    updateShowViewCourseDetailsOverlayFlag (event, flagToUpdate, courseObj) {
      // AK: Used when user pressed View Course details to open View Course Details overlay
      this.showViewCourseDetails = flagToUpdate
      this.selectedCourseObj = courseObj
      // AK: Disable Background scrolling
      this.$store.state.isOverlayVisible = flagToUpdate
    },
    updateShowEditCourseDetailsOverlayFlag (event, flagToUpdate, courseObj) {
      // AK: Used when user pressed Edit Course details to open Edit Course Details overlay
      this.showEditCourseDetails = flagToUpdate
      this.selectedCourseObj = courseObj
      // AK: Disable Background scrolling
      this.$store.state.isOverlayVisible = flagToUpdate
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete Course overlay
      this.showConfirmationBox = value
    },
    performAction (value) {
      // AK: Hide Confirmation Box
      this.showConfirmationBox = false
      if (value) {
        switch (this.prefixString) {
          case 'Are you sure you want to delete ':
            this.deleteCourseMaster()
            break
          case 'Are you sure you want to copy ':
            this.copyCourseMaster()
            break
        }
      }
    },
    deleteCourseMaster: function () {
      var _this = this
      var storeObj = this.$store
      if (
        this.selectedCourseObj.CourseMasterId !== undefined ||
        this.selectedCourseObj !== null
      ) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        this.isCurrentlyShowingSpinner = true
        courseService
          .deleteCourseMaster(storeObj.state.access_token, this.selectedCourseObj.CourseMasterId)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Refresh Course List
              _this.getCourses()
              // console.log(JSON.stringify(responseObj.data))
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.currentlyShowingSpinner = false
            }
          }, errorObj => {
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.currentlyShowingSpinner = false
            this.showAlertDialog = true
            this.errorMsg = errorObj.response.statusText
          })
      } else {
        console.log(
          'Selected COURSE Object is NULL hence declined DELETE COURSE OPERATION'
        )
      }
    },
    copyCourseMaster: function () {
      var _this = this
      var storeObj = this.$store
      if (
        this.selectedCourseObj.CourseMasterId !== undefined ||
        this.selectedCourseObj !== null
      ) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        this.isCurrentlyShowingSpinner = true
        courseService
          .copyCourseMaster(storeObj.state.access_token, this.selectedCourseObj.CourseMasterId)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.$store.state.isLoading = false
              _this.isCurrentlyShowingSpinner = false
              _this.isCourseCopied = true
              _this.showAlertDialog = true
              _this.errorMsg = '\'' + this.selectedCourseObj.CourseTitle + '\' course copied successfully.'
              // console.log('Copy Course >>> ' + JSON.stringify(responseObj.data))
            } else {
              _this.isCourseCopied = false
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.currentlyShowingSpinner = false
            }
          }, errorObj => {
            _this.isCourseCopied = false
            // AK: Hide Spinner
            // this.showSpinner = false
            this.$store.state.isLoading = false
            this.currentlyShowingSpinner = false
            this.showAlertDialog = true
            this.errorMsg = errorObj.response.statusText
          })
      } else {
        console.log(
          'Selected COURSE Object is NULL hence declined DELETE COURSE OPERATION'
        )
      }
    }
  },
  computed: {
    selectedCourseTypeValue: {
      get: function () {
        return this.currCourseType
      },
      set: function (newValue) {
        this.currCourseType = parseInt(newValue)
        return filter(this.getGlobalCourseList, (obj) => {
          return obj.Type !== constants.CourseType.RecommendationAssessment && obj.Type === this.currCourseType
        })
      }
    },
    getCourseList: {
      get: function () {
        return filter(this.getGlobalCourseList, (obj) => {
          return obj.Type !== constants.CourseType.RecommendationAssessment && obj.Type === this.currCourseType
        })
      }
    },
    getGlobalCourseList: {
      get: function () {
        console.log('Global List updated.')
        return this.$store.state.course_list
      }
    }
  },
  watch: {},
  components: {
    'confirmation-alert': ConfirmationOverlay,
    'alert-box': AlertBox,
    'view-course-details': ViewCourseDetailsOverlay,
    'edit-course-details': EditCourseDetailsOverlay,
    'loader': Loader
  },
  name: 'ManageCourseDetailList'
}
</script>

<style scoped>
.vertical-align {
  display: flex;
  align-items: center;
}
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.ManageCourseDetailList{
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

}
.border-right
 {
   border-right: 1px solid #aaa !important;
 }
 .margin-Top-1Perc
{
	margin-top: 1%;
}
 .margin-Top-2Perc
{
	margin-top: 2%;
}
.tdMargin-Top-1Perc
{
	margin-top: 1%;
}
 .margin-left-0Point3Perc
{
	margin-left: 0.3%;
}
 .margin-right-0Point1Perc
{
	margin-right: 0.1%;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
  .table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.text-align-center {
 text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
.text-valign-middle{
  vertical-align: middle;
}
.imgWidthHeight{
  width:180px;
  height:110px;
}
.padding-Top-1Perc{
  padding-Top:1%;
}
.padding-top-2Perc {
  padding-top: 2% !important;
}
a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.btn-text-color{
  color:#2c3e50;
}
.cursor-pointer {
  cursor: pointer;
}
.border-red{
  border: 1px solid red !important;
}
.border-yellow{
  border: 3px solid #efe700 !important;
}
.img-background-color {
  background-color: #d4d4d4 !important;
}
.paddding-right-0px{
  padding-right: 0px !important;
}
.padding-left-0px {
  padding-left: 0px !important;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
.text-align-right {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/ManageCourse.vue